/**
 * SFN i18n — Português (pt-BR). Overlays EN base with professional translations
 * for every REQUIRED_I18N_KEYS entry.
 */
import type { Dict } from "./types";
import { en } from "./en";

export const pt: Dict = {
  ...en,

  // Navigation
  "nav.home": "Início",
  "nav.about": "Sobre",
  "nav.contact": "Contato",
  "nav.ecosystem": "Ecossistema",
  "nav.tokens": "Tokens",
  "nav.protection": "Proteção",
  "nav.secure": "Reservar",
  "nav.faq": "Perguntas frequentes",
  "nav.connectWallet": "Conectar carteira",
  "nav.language": "Idioma",

  // Hero
  "hero.eyebrow": "Proteção contra inflação de $1 verificada na Solana",
  "hero.stat1": "Refeições garantidas",
  "hero.stat2": "Lastro em ativos reais",
  "hero.stat3": "Liquidação média",

  // Bento
  "bento.title": "Sustainable Food & Eco Network (SFN): como funciona",
  "bento.sub": "Tokenomics, utilidade e resiliência — compostos como um menu de degustação.",
  "bento.card1.title": "A visão e a rede (SFN)",
  "bento.card1.text":
    "A SFN é uma rede aberta e descentralizada de cozinhas parceiras certificadas, agricultores locais e apoiadores. Ao unir financiamento comunitário e operações movidas a energia solar, mantemos os custos de produção de alimentos imbatíveis e estáveis.",
  "bento.card2.title": "Hub regional de sourcing descentralizado",
  "bento.card2.text":
    "Nossa operação âncora funciona como um campo de teste real onde a fórmula de refeição a 30 THB é validada diariamente. Deste hub coordenamos compras em escala, infraestrutura de cozinha movida a energia solar e os padrões operacionais que cada unidade parceira herda.",
  "bento.card3.title": "Impacto global escalável",
  "bento.card3.text":
    "Não paramos em uma única cozinha. A SFN foi feita para crescer. Apoiadores internacionais podem patrocinar refeições digitalmente, e cozinhas locais tradicionais podem entrar na rede e acessar ingredientes subsidiados e energia solar.",

  // Pilot / Sandbox
  "pilot.eyebrow": "Piloto ao vivo, prova de conceito: Thailand Sandbox",
  "pilot.title": "Tailândia: mercado piloto da Fase 1 (zona sandbox)",
  "pilot.body":
    "Iniciar em um mercado regional altamente eficiente nos permite testar sob estresse a tokenomics MEAL4/MEAL2 e a cadeia de suprimentos real com máximo controle operacional. Cada cozinha, cada fluxo de ingredientes e cada caminho de liquidação é validado em ambiente contido antes da SFN executar sua expansão internacional.",
  "pilot.benchmark.label": "Referência global de $1",
  "pilot.benchmark.value": "$1",
  "pilot.benchmark.desc": "Ancoramos o preço da refeição em 30 THB ($1) ou menos, usando mecânicas Web3 localizadas para provar escalabilidade global.",
  "pilot.phase1": "Fase 1: piloto regional (meta $1)",
  "pilot.phase2": "Fase 2: escalabilidade global",
  "pilot.phase.arrow": "Trajetória do roadmap",
  "pilot.stat1.label": "Mercado piloto",
  "pilot.stat1.value": "Tailândia · Thailand Sandbox",
  "pilot.stat2.label": "Âncora da refeição",
  "pilot.stat2.value": "$1",
  "pilot.stat3.label": "Próxima fase",
  "pilot.stat3.value": "Lançamento global",

  // About
  "about.eyebrow": "Fundadores e missão",
  "about.titleA": "Por trás da",
  "about.titleB": "Sustainable Food & Eco Network",
  "about.body":
    "A SFN foi fundada por uma equipe empreendedora que une a clássica administração alemã à gastronomia real da Tailândia. Ao presenciar o impacto direto da inflação global sobre comunidades locais, decidimos usar a tecnologia blockchain não para especulação, mas para a estabilidade humana básica. Nossa cozinha piloto em Thailand é o modelo operacional para um futuro transparente, movido a energia solar e descentralizado de segurança alimentar.",

  // Contact
  "contact.eyebrow": "Consulta de parceria",
  "contact.titleA": "Faça parte",
  "contact.titleB": "da rede",
  "contact.body":
    "Você é uma cozinha local querendo aceitar tokens MEAL, um produtor que deseja fornecer diretamente ou um apoiador internacional com dúvidas? Fale conosco.",
  "contact.name": "Nome",
  "contact.namePh": "Seu nome",
  "contact.email": "E-mail",
  "contact.emailPh": "voce@exemplo.com",
  "contact.subject": "Assunto",
  "contact.subjectPh": "Parceria, fornecimento, suporte…",
  "contact.message": "Mensagem",
  "contact.messagePh": "Conte-nos sobre seu projeto ou pergunta…",
  "contact.sent": "Mensagem transmitida com segurança",
  "contact.successBody":
    "Sua mensagem foi entregue pelo nosso canal criptografado. Um membro do time responderá em até 48 horas.",
  "contact.errorTitle": "Falha na transmissão",
  "contact.errorBody": "Não foi possível entregar sua mensagem. Verifique a conexão e tente novamente.",
  "contact.dismissOk": "Enviar outra",
  "contact.dismissError": "Tentar novamente",
  "contact.responseNote": "Costumamos responder em até 48 horas.",
  "contact.send": "Enviar mensagem",

  // Dual-token
  "dual.eyebrow": "Arquitetura de dois tokens",
  "dual.title": "Sistema de dois tokens: segurança encontra utilidade",
  "dual.sub":
    "MEAL4 move valor. MEAL2 o mantém parado. Juntos, tornam a segurança alimentar realmente utilizável.",
  "dual.meal4.t": "MEAL4 — Escudo contra a inflação",
  "dual.meal4.d":
    "Estritamente limitado a 1.000.000 tokens, sem qualquer possibilidade de emissão adicional. O MEAL4 é um contrato digital lastreado em reservas de ativos físicos e poder de compra estratégico em escala. Ele congela o custo de produção da comida na origem e forma um hedge deflacionário contra a alta dos preços.",
  "dual.meal2.t": "MEAL2 — Utilidade diária",
  "dual.meal2.d":
    "Token prático do dia a dia, feito para operações fluidas nos restaurantes, recompensas e apoio comunitário. O MEAL2 move o ecossistema com pagamentos móveis instantâneos, descontos de fidelidade para clientes locais e patrocínios digitais transparentes de refeições vindos de apoiadores globais.",

  // Protection
  "protection.eyebrow": "Segurança imutável · On-chain",
  "protection.title": "Confiança irrevogável escrita em código",
  "protection.sub":
    "Codificamos parâmetros rigorosos de segurança diretamente nos contratos inteligentes, protegendo a comunidade contra inflação e alterações não autorizadas.",
  "protection.f1.title": "Ativos 100% à prova de congelamento",
  "protection.f1.text":
    "A ‘Freeze Authority’ dos dois tokens foi revogada permanentemente. Nenhum poder central, instituição ou desenvolvedor pode congelar sua carteira ou impedir o uso dos seus MEAL.",
  "protection.f2.title": "Teto de emissão fixado no código (MEAL4)",
  "protection.f2.text":
    "A ‘Mint Authority’ do MEAL4 foi destruída de forma irreversível. É matematicamente impossível emitir mais de 1.000.000 MEAL4, protegendo para sempre seu hedge de segurança alimentar contra a diluição.",
  "protection.f3.title": "Crescimento flexível de utilidade (MEAL2)",
  "protection.f3.text":
    "Mantivemos intencionalmente a capacidade de emissão do MEAL2 para escalar de forma fluida com novas cozinhas parceiras que entram na Sustainable Food & Eco Network, assegurando combustível transacional às economias locais.",

  // Swap
  "swap.eyebrow": "Venda de tokens",
  "swap.title": "Garanta suas refeições",
  "swap.sub":
    "Troque diretamente por MEAL4. Cada token garante uma refeição na nossa cozinha parceira — hoje, amanhã, após qualquer crise.",
  "swap.connectWallet": "Conecte a carteira para trocar",
  "swap.meal4.milestoneLabel":
    "Marco atual: Meta da Fase 1 — Infraestrutura da Cozinha Central de Thailand Sandbox e expansão Express inicial",
  "swap.meal4.milestoneProgress": "{raised} / {goal} USDC arrecadados",
  "swap.meal4.percent": "{pct}% financiado",
  "swap.meal4.treasuryLabel": "Carteira do tesouro do projeto",
  "swap.meal4.treasuryNote":
    "Contribuições vão diretamente para o tesouro do projeto SFN — sem DEX e sem roteamento em mercado aberto.",
  "swap.meal4.tooltip":
    "A distribuição dos tokens é lastreada por estoque físico e gerenciada em etapas de financiamento por marcos para garantir estabilidade de preço.",
  "swap.meal4.tooltipAria": "Como funciona o financiamento por marcos",
  "swap.meal2.rateLabel": "Câmbio fixo · 1 USDC = 1 MEAL2",
  "swap.meal2.payWith": "Pagar com",
  "swap.meal2.solRoute": "Rota automática: SOL → USD (Jupiter) → MEAL2 a $1 por unidade",
  "swap.meal2.priceFallback": "preço de referência (feed offline)",
  "swap.phantomApproving": "Aguardando aprovação da Phantom…",

  // Trust
  "trust.eyebrow": "Transparência e confiança",
  "trust.title": "Lastreado por coisas em que você pode tocar.",
  "trust.body":
    "O ecossistema é ancorado por ativos físicos: nosso restaurante parceiro ‘a Cozinha-Piloto SFN’ na Tailândia, imóveis de suporte e uma cozinha em operação servindo pratos reais todos os dias. Divulgamos regiões e operações abertamente — endereços exatos são preservados pela segurança da equipe e dos clientes.",

  // FAQ
  "faq.eyebrow": "Perguntas frequentes",
  "faq.title": "Perguntas frequentes",
  "faq.sub":
    "Tudo o que você precisa saber sobre a Sustainable Food & Eco Network (SFN) e nosso ecossistema de estabilização de refeições.",
  "faq.q1": "Como vocês garantem uma refeição saudável e de qualidade por $1 diante da inflação?",
  "faq.a1":
    "Combinamos três pilares: compras estratégicas em escala direto com agricultores locais, redução dos custos operacionais do restaurante via infraestrutura solar e apoio da comunidade pelo escudo antifogo do MEAL4. Isso desconecta totalmente o preço base da nossa cozinha da inflação volátil do mercado.",
  "faq.q2": "Um único restaurante consegue atender à demanda se o token escalar?",
  "faq.a2":
    "Não — e não precisa. O ‘a Cozinha-Piloto SFN’ é nossa prova de conceito viva; a arquitetura maior é a SFN. Com o crescimento da demanda, cozinhas independentes locais entram na rede e acessam ingredientes e infraestrutura subsidiados para escalar a promessa dos 30 THB globalmente.",
  "faq.q3": "Como apoiadores internacionais podem participar se não moram na Tailândia?",
  "faq.a3":
    "Apoiadores globais podem comprar MEAL2 para iniciar ‘Patrocínios de Refeição’ digitais. Esses tokens são alocados de forma transparente a programas locais de assistência, permitindo que idosos, famílias de baixa renda e grupos vulneráveis comam gratuitamente ou por 30 THB em qualquer cozinha SFN certificada.",
  "faq.q4": "O que diferencia o MEAL4 de uma criptomoeda comum?",
  "faq.a4":
    "Diferentemente de tokens especulativos, o MEAL4 é um contrato prático lastreado na expansão de reservas físicas de alimentos e infraestrutura gastronômica sustentável. Com a autoridade de emissão destruída para sempre, funciona como uma reserva de valor matematicamente limitada, feita para segurança alimentar.",

  // Roadmap
  "roadmap.eyebrow": "Execução · Trajetória",
  "roadmap.title": "Do chão de fábrica ao protocolo global",
  "roadmap.sub":
    "Uma história de seis etapas de iteração real. Cada marco está ancorado em realidade operacional, não em slides.",
  "roadmap.card1.title": "Alimentação para operários",
  "roadmap.card1.desc":
    "Observamos a inflação diária dos alimentos ultrapassar 45 THB por refeição, deixando trabalhadores e comunidades de baixa renda cada vez mais fora do alcance de uma nutrição saudável.",
  "roadmap.card2.title": "Conceito do framework $1",
  "roadmap.card2.desc":
    "Projetamos o arcabouço econômico central com margem estável de 30 THB — o alicerce para uma refeição permanentemente acessível e de qualidade.",
  "roadmap.card3.title": "Testes de sourcing na cadeia",
  "roadmap.card3.desc":
    "Rodamos pilotos de sourcing direto com agricultores e detectamos as limitações estruturais do modelo de unidade única, fundamentando um hub regional de compras descentralizado.",
  "roadmap.card4.title": "Escalonamento multiloja e raízes solares",
  "roadmap.card4.desc":
    "A expansão para várias unidades revelou padrões consistentes de sobrecarga energética, validando a infraestrutura solar como a camada de estabilização de custo que faltava.",
  "roadmap.card5.title": "Prova operacional e piloto $1",
  "roadmap.card5.desc":
    "Alcançamos estabilidade absoluta de vendas durante o mês inteiro — sem quedas no meio do mês — comprovando que o modelo de 30 THB é operacionalmente sustentável em escala.",
  "roadmap.card6.title": "Tokenização SFN e sprint SolarPando",
  "roadmap.card6.desc":
    "Lançamento oficial da SFN na Solana: gênese dos tokens MEAL4 e MEAL2, verificação de imutabilidade e o sprint de infraestrutura SolarPando entram no ar.",

  // Docs
  "docs.eyebrow": "Base de conhecimento",
  "docs.title": "White Paper e documentos legais",
  "docs.sub": "Baixe a documentação oficial da SFN e os relatórios de auditoria.",
  "credits.line": "Conceito e estrutura criados por Boy Khomkrit — Lançamento inicial: 04 de julho de 2021",
  "credits.date": "Data de criação original: 04 de julho de 2021 (04.07.2021)",
  "credits.version": "Whitepaper v1.0 — Lançamento original: 04 de julho de 2021",
  "docs.btn1": "White Paper do ecossistema SFN (EN)",
  "docs.btn2": "Resumo executivo de tokenomics (DE)",
  "docs.btn3": "Arcabouço legal da gastronomia na Tailândia",
  "docs.btn4": "Relatório de auditoria de segurança criptográfica",

  // Verify
  "verify.meal4.title": "MEAL4 — Verificação do escudo contra inflação",
  "verify.meal4.sub": "Parâmetros de ativo imutáveis",
  "verify.meal4.cta": "Ver MEAL4 no Solana Explorer",
  "verify.meal2.title": "MEAL2 — Verificação da utilidade diária",
  "verify.meal2.sub": "Parâmetros de utilidade flexíveis",
  "verify.meal2.cta": "Ver MEAL2 no Solana Explorer",
  "verify.item.meal4Supply.label": "Teto de fornecimento MEAL4 verificado",
  "verify.item.meal4Supply.statusPassed": "APROVADO — limitado a 1.000.000",
  "verify.item.meal4Supply.statusLive": "APROVADO — Fornecimento on-chain: ",
  "verify.item.meal4Mint.label": "Mint Authority do MEAL4",
  "verify.item.meal4Mint.statusPassed": "APROVADO — Destruída (limite fixo de 1M)",
  "verify.item.meal4Mint.statusActive": "ATIVA — Mint Authority presente",
  "verify.item.meal4Freeze.label": "Freeze Authority do MEAL4",
  "verify.item.meal4Freeze.statusPassed": "APROVADO — Revogada (sem controle central)",
  "verify.item.meal4Freeze.statusActive": "ATIVA — Freeze Authority presente",
  "verify.item.meal2Freeze.label": "Freeze Authority do MEAL2",
  "verify.item.meal2Freeze.statusPassed": "APROVADO — Revogada (liquidez liberada)",
  "verify.item.meal2Freeze.statusActive": "ATIVA — Freeze Authority presente",
  "verify.item.meal2Mint.label": "Mint Authority do MEAL2",
  "verify.item.meal2Mint.statusRevoked": "REVOGADA — Emissão congelada",
  "verify.item.meal2Mint.statusActive": "ATIVA — Gerida pelo SFN Growth Protocol",
  "verify.item.meal2Supply.label": "Fornecimento circulante do MEAL2",
  "verify.item.meal2Supply.statusLive": "AO VIVO — ",
  "verify.badge.connecting": "Conectando",
  "verify.badge.cached": "Em cache",
  "verify.badge.verified": "Verificado",
  "verify.networkBusy": "Rede ocupada, tentando reconectar… (tentativa ",

  // Transparency
  "transparency.jsonImmutable": "// Imutável. Não pode ser alterado.",
  "transparency.jsonCeiling": "// Teto fixado no código.",

  // Connection
  "connection.eyebrow": "// A conexão",
  "connection.step1.title": "Compras em escala",
  "connection.step1.text":
    "As reservas de MEAL4 financiam sourcing direto e em grande volume junto a agricultores locais, fixando o custo dos ingredientes abaixo da inflação de mercado.",
  "connection.step2.title": "Infraestrutura solar",
  "connection.step2.text":
    "Sistemas solares off-grid alimentam as cozinhas parceiras 24/7, eliminando a volatilidade energética do custo de cada prato.",
  "connection.step3.title": "Refeições resgatáveis",
  "connection.step3.text":
    "O cliente escaneia, paga em MEAL2 e recebe um prato quente e nutritivo por menos de USD 1 — um contrato digital resolvido em uma mesa real.",

  // Barometer
  "barometer.eyebrow": "AO VIVO · On-chain · Verificado",
  "barometer.title.a": "Real",
  "barometer.title.b": "Barômetro de estoque",
  "barometer.sub":
    "Uma janela transparente para as reservas físicas que sustentam cada refeição. Números atualizados a partir da cozinha piloto — sem especulação, só estoque.",
  "barometer.rice": "Reservas de arroz",
  "barometer.oil": "Óleo vegetal",
  "barometer.solar": "Status da energia solar",

  // Footer
  "footer.tag":
    "SFN (Sustainable Food & Eco Network) e MealToken24 dedicam-se a transformar a tecnologia blockchain em ferramenta contra a inflação e a insegurança alimentar global. Movida por cozinhas reais, construída para pessoas reais.",
  "footer.disclaimer":
    "Aviso legal: MEAL2 e MEAL4 são tokens comunitários utilitários e lastreados em ativos, projetados para uso prático no ecossistema gastronômico da Sustainable Food & Eco Network. Não constituem investimento financeiro nem valores mobiliários tradicionais.",
  "footer.about": "Sobre",
  "footer.contact": "Contato",
  "footer.legal": "Legal",
  "footer.rights": "Todos os direitos reservados.",

  // Milestones
  "milestones.eyebrow": "ROADMAP IMEDIATO: CONECTANDO BLOCKCHAIN À INFRAESTRUTURA FÍSICA",
  "milestones.p1.title": "Hub de cozinha central SFN (Thailand Sandbox)",
  "milestones.p1.desc":
    "Financiada por capital institucional, nossa futura central de processamento automatizada cuidará das compras em escala, refrigeração solar e preparo de refeições zero-waste. Isso elimina custos de intermediação e garante estabilidade de preço antes da distribuição.",
  "milestones.p1.target": "Cadeia de suprimentos 100% interligada por energia solar.",
  "milestones.p2.title": "Hiperexpansão de unidades Smart Express",
  "milestones.p2.desc":
    "Escalar o modelo gastronômico já validado da unidade âncora para uma rede regional de pontos expressos de alta eficiência ao longo dos principais corredores de alto tráfego. Cada ponto opera com energia subsidiada de custo zero.",
  "milestones.p2.target": "Rollout regional multilocal em sandbox.",

  // VillagePando additions (Phase A)
  "vp.swap.pegged.badge": "Voucher 1:1 lastreado em USDC",
  "vp.swap.pegged.tooltip":
    "Cada voucher VillagePando é lastreado 1:1 por uma reserva em USDC e pode ser resgatado pelo valor de face a qualquer momento.",
  "vp.swap.tax.eyebrow": "5% Imposto Solar",
  "vp.swap.tax.title": "Para onde vão esses 5%?",
  "vp.swap.tax.intro":
    "Os 5% deduzidos automaticamente em cada transação são 100% roteados para infraestrutura pública verificável — nunca como lucro do projeto.",
  "vp.swap.tax.total": "Imposto total",
  "vp.swap.tax.perTx": "Por transação",
  "vp.swap.tax.hardware.label": "Fundo de hardware solar",
  "vp.swap.tax.hardware.detail":
    "Compra painéis solares off-grid, inversores e armazenamento em bateria para cozinhas parceiras e nós comunitários.",
  "vp.swap.tax.reforestation.label": "Reflorestamento e terra",
  "vp.swap.tax.reforestation.detail":
    "Financia o plantio de espécies nativas e a regeneração do solo em parcelas registradas, com rastro on-chain.",
  "vp.swap.tax.ops.label": "Operações e conformidade",
  "vp.swap.tax.ops.detail":
    "Cobre manutenção de hardware, treinamento das equipes de instalação e custos de conformidade multijurisdicional.",
  "vp.nexus.trio.eyebrow": "// Pando-Trio · Fluxo circular",
  "vp.nexus.trio.caption":
    "A terra alimenta a água. A água alimenta a energia. A energia recompra a refeição. A refeição sustenta a vila.",
  "vp.nexus.trio.step1": "Terra → Água",
  "vp.nexus.trio.step2": "Água → Energia",
  "vp.nexus.trio.step3": "Energia → Recompra da refeição",
  "vp.nexus.trio.step4": "Refeição → Vila",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Roadmap",
  "nav.vision": "Visão",
  "nav.whitepaper": "White Paper",

  // Treasury transparency & purchase receipt
  "treasury.eyebrow": "Transparência de liquidação",
  "treasury.title": "Toda compra de MEAL2 e MEAL4 é liquidada em uma única tesouraria",
  "treasury.desc": "As compras nunca passam por uma DEX ou carteira intermediária. O endereço completo aparece ao passar o mouse e é verificado on-chain antes de qualquer botão ser liberado.",
  "treasury.label": "Tesouraria do projeto",
  "treasury.network": "Rede",
  "treasury.copy": "Copiar endereço",
  "treasury.copied": "Copiado",
  "treasury.explorer": "Ver no explorador",
  "treasury.status.checking": "Verificando destino",
  "treasury.status.verified": "Destino verificado",
  "treasury.status.degraded": "Endereço válido · rede congestionada",
  "treasury.status.invalid": "Destino não verificado — compras desativadas",
  "receipt.eyebrow": "Transação liquidada",
  "receipt.title": "Confirmação de compra",
  "receipt.desc": "Sua contribuição foi encaminhada à tesouraria do projeto SFN. Guarde a assinatura abaixo como comprovante de liquidação.",
  "receipt.amount": "Pago",
  "receipt.received": "Recebido",
  "receipt.destination": "Destino na tesouraria",
  "receipt.network": "Rede",
  "receipt.hash": "Assinatura da transação",
  "receipt.viewExplorer": "Ver transação no explorador",
  "receipt.close": "Fechar confirmação",
  "receipt.copyHash": "Copiar hash",
  "receipt.hashCopied": "Hash copiado",
  "receipt.download": "Baixar JSON",
  "rpc.checking": "Verificando o destino na rede…",
  "rpc.degraded": "Rede congestionada — endereço válido, verificação on-chain em nova tentativa",
  "rpc.invalid": "Destino não verificado — compras desativadas",

  // Analytics consent
  "consent.title": "Consentimento de analytics",
  "consent.desc": "Usamos analytics de produto anônimo e sem cookies (sem IP, sem fingerprint) para melhorar esta página. Nada é enviado antes do seu aceite.",
  "consent.accept": "Aceitar",
  "consent.decline": "Recusar",
  "meal2.tab.web3": "Swap digital (Web3)",
  "hero.title": "Congelando o preço da comida: uma refeição saudável por $1 — para sempre.",
  "hero.sub": "Utilidade simples. Infraestrutura real. Movido por Meal2 e Meal4.",
  "hero.badge": "A primeira infraestrutura alimentar de token duplo do mundo — protegendo contra a inflação dos alimentos, uma refeição de $1 por vez.",
  "hero.cta": "Comprar Meal2 (refeição de $1)",
  "hero.ghost": "Obter Meal4 (governança)",
  "keep.title": "Como mantemos as refeições a $1",
  "keep.sub": "Três ativos reais absorvem a pressão de custos para que o preço do prato não mude.",
  "keep.solar.title": "Energia solar",
  "keep.solar.text": "Energia solar off-grid alimenta cada cozinha e tira a conta de luz do custo da refeição.",
  "keep.agri.title": "Agricultura",
  "keep.agri.text": "Compra direta das fazendas e reflorestamento travam o custo dos ingredientes sem intermediários.",
  "keep.water.title": "Água limpa",
  "keep.water.text": "Reservatórios de água filtrada garantem a produção diária na seca sem custo variável.",
  "brand.tagline": "O motor de comida de $1",
  "nav.product": "Produto",
  "nav.pilot": "Cozinhas piloto",
  "trustpilot.eyebrow": "Prova de conceito · Região piloto",
  "trustpilot.title": "Comprovado na Tailândia — expandindo globalmente.",
  "trustpilot.desc": "Nossa cozinha âncora e o hub comunitário já estão em operação. Cada mecanismo descrito aqui é testado com pratos, produtores e comunidades reais antes de escalar.",
  "trustpilot.b1": "Cozinha âncora operando diariamente",
  "trustpilot.b2": "Rede regional de produtores",
  "trustpilot.b3": "Hub comunitário movido a energia solar",
  "trustpilot.b4": "Liquidação on-chain ao vivo",
  "swap.quote.title": "Cotação da rota ao vivo",
  "swap.quote.slippage": "Slippage máximo",
  "swap.quote.expiry": "Validade da cotação",
  "swap.quote.minReceive": "Mínimo recebido",
  "swap.quote.usdValue": "Valor estimado",
  "swap.quote.expiresIn": "Atualiza em {s}s",
  "swap.quote.expired": "Cotação expirada — atualize",
  "swap.quote.refresh": "Atualizar cotação",
  "swap.quote.expiredError": "Sua cotação expirou. Atualize a taxa e tente novamente.",
  "swap.quote.slippageError": "A taxa do SOL ultrapassou seu limite de slippage. Nada foi assinado.",
  "verify.badge": "Comprovante de compra",
  "verify.title": "Verificar meu recibo",
  "verify.intro": "Cole a assinatura da sua transação Solana para confirmar a compra diretamente na rede e no livro-razão SFN. A verificação roda no servidor — sem conectar carteira.",
  "verify.modalIntro": "Status on-chain verificado no servidor e o registro correspondente.",
  "verify.label": "Assinatura da transação",
  "verify.placeholder": "Cole a assinatura da sua transação Solana",
  "verify.submit": "Verificar recibo",
  "verify.busy": "Verificando…",
  "verify.close": "Fechar verificação de recibo",
  "verify.verified": "Verificado on-chain",
  "verify.unreachable": "Rede indisponível — tente novamente em instantes",
  "verify.notConfirmed": "Não confirmado",
  "verify.invalid": "Esta não é uma assinatura Solana válida.",
  "verify.rateLimited": "Muitas consultas. Aguarde um minuto e tente de novo.",
  "verify.replay": "Você já consultou esta assinatura nesta sessão.",
  "verify.error": "O serviço de verificação está ocupado. Tente novamente em instantes.",
  "verify.receiptId": "ID do recibo",
  "verify.signature": "Assinatura",
  "verify.ledgerEntry": "Registro no livro-razão",
  "verify.purchase": "Compra",
  "verify.value": "Valor",
  "verify.wallet": "Carteira",
  "verify.checks": "Verificações de liquidação",
  "verify.noLedger": "Ainda não há registro SFN para esta assinatura. Se você acabou de pagar, aguarde alguns segundos e tente de novo.",
  "verify.explorer": "Ver no Solscan",
  "admin.csv.export": "Baixar CSV",
  "admin.csv.exportLabel": "Baixar o livro-razão de vendas em CSV",
  "dexRoadmap.title": "Roteiro rumo à liquidez e indexação",
  "dexRoadmap.phase1": "Pré-venda e lançamento de utilidade",
  "dexRoadmap.phase2": "Strict List da Jupiter e pool de liquidez na Raydium",
  "dexRoadmap.phase3": "Indexação do token no CoinGecko e CoinMarketCap",
  "dexRoadmap.active": "Ativo",
  "dexRoadmap.status.active": "Ativo",
  "dexRoadmap.status.next": "Próximo",
  "dexRoadmap.status.planned": "Planejado",
  "dexRoadmap.statusLive": "O status das fases do roteiro está ao vivo.",
  "dexRoadmap.statusFallback": "Status ao vivo indisponível — exibindo o plano publicado.",
  "dexRoadmap.visit": "Abrir {name} em uma nova aba",
  "swap.quote.refreshing": "Atualizando a cotação…",
};
